/**
 * Builds an absolute API URL from a path, normalizing the configured base.
 *
 * Handles every VITE_API_BASE_URL form consistently:
 *   ""                     -> "/api/v1/..."
 *   "/"                    -> "/api/v1/..."
 *   "https://example.com/" -> "https://example.com/api/v1/..."
 *
 * A relative result (e.g. "api/v1/...") would resolve against the current SPA
 * route and hit the app shell instead of the API, so the leading slash is
 * always guaranteed here.
 */
export function apiUrl(path: string): string {
  const base = (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/+$/, "");
  return `${base}/${path.replace(/^\/+/, "")}`;
}
